var map = {
	"./level1.png": [
		50486
	],
	"./level1/pic1.png": [
		35366,
		35366
	],
	"./level1/pic10-1.png": [
		81726,
		81726
	],
	"./level1/pic10-2.png": [
		48275,
		48275
	],
	"./level1/pic10-3.png": [
		78190,
		78190
	],
	"./level1/pic10-4.png": [
		43611,
		43611
	],
	"./level1/pic10.png": [
		61457,
		61457
	],
	"./level1/pic11-1.png": [
		20667,
		20667
	],
	"./level1/pic11-2.png": [
		65023,
		65023
	],
	"./level1/pic11-3.png": [
		51323,
		51323
	],
	"./level1/pic11-4.png": [
		96821,
		96821
	],
	"./level1/pic11.png": [
		2898,
		2898
	],
	"./level1/pic12-1.png": [
		17870,
		17870
	],
	"./level1/pic12-2.png": [
		8152,
		8152
	],
	"./level1/pic12-3.png": [
		25917,
		25917
	],
	"./level1/pic12-4.png": [
		32073,
		32073
	],
	"./level1/pic12.png": [
		82243,
		82243
	],
	"./level1/pic13.png": [
		96013,
		96013
	],
	"./level1/pic14-1.png": [
		39616,
		39616
	],
	"./level1/pic14-2.png": [
		74405,
		74405
	],
	"./level1/pic14-3.png": [
		22294,
		22294
	],
	"./level1/pic14-4.png": [
		79471,
		79471
	],
	"./level1/pic14.png": [
		68655,
		68655
	],
	"./level1/pic15-1.png": [
		4935,
		4935
	],
	"./level1/pic15-2.png": [
		3505,
		3505
	],
	"./level1/pic15-3.png": [
		88362,
		88362
	],
	"./level1/pic15-4.png": [
		25372,
		25372
	],
	"./level1/pic15.png": [
		33716,
		33716
	],
	"./level1/pic16-1.png": [
		3276,
		3276
	],
	"./level1/pic16-2.png": [
		19755,
		19755
	],
	"./level1/pic16-3.png": [
		32028,
		32028
	],
	"./level1/pic16-4.png": [
		13702,
		13702
	],
	"./level1/pic16.png": [
		47652,
		47652
	],
	"./level1/pic17-1.png": [
		39116,
		39116
	],
	"./level1/pic17-2.png": [
		94109,
		94109
	],
	"./level1/pic17-3.png": [
		88034,
		88034
	],
	"./level1/pic17-4.png": [
		70659,
		70659
	],
	"./level1/pic17.png": [
		67716,
		67716
	],
	"./level1/pic18-1.png": [
		22161,
		22161
	],
	"./level1/pic18-2.png": [
		9126,
		9126
	],
	"./level1/pic18-3.png": [
		52752,
		52752
	],
	"./level1/pic18-4.png": [
		80081,
		80081
	],
	"./level1/pic18.png": [
		40055,
		40055
	],
	"./level1/pic19.png": [
		79652,
		79652
	],
	"./level1/pic2-1.png": [
		30161,
		30161
	],
	"./level1/pic2-2.png": [
		29669,
		29669
	],
	"./level1/pic2-3.png": [
		23410,
		23410
	],
	"./level1/pic2-4.png": [
		46863,
		46863
	],
	"./level1/pic2.png": [
		86583,
		86583
	],
	"./level1/pic20-1.png": [
		62809,
		62809
	],
	"./level1/pic20-2.png": [
		24418,
		24418
	],
	"./level1/pic20-3.png": [
		92188,
		92188
	],
	"./level1/pic20-4.png": [
		96290,
		96290
	],
	"./level1/pic20.png": [
		54267,
		54267
	],
	"./level1/pic21-1.png": [
		64347,
		64347
	],
	"./level1/pic21-2.png": [
		54284,
		54284
	],
	"./level1/pic21-3.png": [
		73513,
		73513
	],
	"./level1/pic21-4.png": [
		29154,
		29154
	],
	"./level1/pic21.png": [
		56692,
		56692
	],
	"./level1/pic22-1.png": [
		84509,
		84509
	],
	"./level1/pic22-2.png": [
		27726,
		27726
	],
	"./level1/pic22-3.png": [
		35373,
		35373
	],
	"./level1/pic22-4.png": [
		7904,
		7904
	],
	"./level1/pic22.png": [
		35370,
		35370
	],
	"./level1/pic23-1.png": [
		21242,
		21242
	],
	"./level1/pic23-2.png": [
		33158,
		33158
	],
	"./level1/pic23-3.png": [
		36060,
		36060
	],
	"./level1/pic23-4.png": [
		25763,
		25763
	],
	"./level1/pic23.png": [
		99769,
		99769
	],
	"./level1/pic24-1.png": [
		45538,
		45538
	],
	"./level1/pic24-2.png": [
		7430,
		7430
	],
	"./level1/pic24-3.png": [
		74425,
		74425
	],
	"./level1/pic24-4.png": [
		2204,
		2204
	],
	"./level1/pic24.png": [
		72208,
		72208
	],
	"./level1/pic25.png": [
		30264,
		30264
	],
	"./level1/pic26-1.png": [
		6368,
		6368
	],
	"./level1/pic26-2.png": [
		43377,
		43377
	],
	"./level1/pic26-3.png": [
		88887,
		88887
	],
	"./level1/pic26-4.png": [
		49653,
		49653
	],
	"./level1/pic26.png": [
		48530,
		48530
	],
	"./level1/pic27-1.png": [
		34265,
		34265
	],
	"./level1/pic27-2.png": [
		99689,
		99689
	],
	"./level1/pic27-3.png": [
		86330,
		86330
	],
	"./level1/pic27-4.png": [
		43952,
		43952
	],
	"./level1/pic27.png": [
		9914,
		9914
	],
	"./level1/pic28-1.png": [
		76024,
		76024
	],
	"./level1/pic28-2.png": [
		491,
		491
	],
	"./level1/pic28-3.png": [
		63104,
		63104
	],
	"./level1/pic28-4.png": [
		60032,
		60032
	],
	"./level1/pic28.png": [
		93725,
		93725
	],
	"./level1/pic29-1.png": [
		79264,
		79264
	],
	"./level1/pic29-2.png": [
		21020,
		21020
	],
	"./level1/pic29-3.png": [
		391,
		391
	],
	"./level1/pic29-4.png": [
		42821,
		42821
	],
	"./level1/pic29.png": [
		86213,
		86213
	],
	"./level1/pic3-1.png": [
		1949,
		1949
	],
	"./level1/pic3-2.png": [
		38706,
		38706
	],
	"./level1/pic3-3.png": [
		45718,
		45718
	],
	"./level1/pic3-4.png": [
		18374,
		18374
	],
	"./level1/pic3.png": [
		72753,
		72753
	],
	"./level1/pic30-1.png": [
		79368,
		79368
	],
	"./level1/pic30-2.png": [
		84705,
		84705
	],
	"./level1/pic30-3.png": [
		91813,
		91813
	],
	"./level1/pic30-4.png": [
		20919,
		20919
	],
	"./level1/pic30.png": [
		52134,
		52134
	],
	"./level1/pic31.png": [
		92053,
		92053
	],
	"./level1/pic32-1.png": [
		67684,
		67684
	],
	"./level1/pic32-2.png": [
		48863,
		48863
	],
	"./level1/pic32-3.png": [
		64469,
		64469
	],
	"./level1/pic32-4.png": [
		85343,
		85343
	],
	"./level1/pic32.png": [
		74492,
		74492
	],
	"./level1/pic33-1.png": [
		62673,
		62673
	],
	"./level1/pic33-2.png": [
		6945,
		6945
	],
	"./level1/pic33-3.png": [
		53611,
		53611
	],
	"./level1/pic33-4.png": [
		39655,
		39655
	],
	"./level1/pic33.png": [
		37049,
		37049
	],
	"./level1/pic34-1.png": [
		80090,
		80090
	],
	"./level1/pic34-2.png": [
		99209,
		99209
	],
	"./level1/pic34-3.png": [
		29897,
		29897
	],
	"./level1/pic34-4.png": [
		7217,
		7217
	],
	"./level1/pic34.png": [
		25815,
		25815
	],
	"./level1/pic35-1.png": [
		62798,
		62798
	],
	"./level1/pic35-2.png": [
		54017,
		54017
	],
	"./level1/pic35-3.png": [
		85274,
		85274
	],
	"./level1/pic35-4.png": [
		2476,
		2476
	],
	"./level1/pic35.png": [
		56258,
		56258
	],
	"./level1/pic36-1.png": [
		49341,
		49341
	],
	"./level1/pic36-2.png": [
		84570,
		84570
	],
	"./level1/pic36-3.png": [
		93405,
		93405
	],
	"./level1/pic36-4.png": [
		51134,
		51134
	],
	"./level1/pic36.png": [
		74608,
		74608
	],
	"./level1/pic37.png": [
		11351,
		11351
	],
	"./level1/pic38-1.png": [
		26563,
		26563
	],
	"./level1/pic38-2.png": [
		78548,
		78548
	],
	"./level1/pic38-3.png": [
		18620,
		18620
	],
	"./level1/pic38-4.png": [
		50148,
		50148
	],
	"./level1/pic38.png": [
		9618,
		9618
	],
	"./level1/pic39-1.png": [
		57592,
		57592
	],
	"./level1/pic39-2.png": [
		77037,
		77037
	],
	"./level1/pic39-3.png": [
		10724,
		10724
	],
	"./level1/pic39-4.png": [
		85688,
		85688
	],
	"./level1/pic39.png": [
		44979,
		44979
	],
	"./level1/pic4-1.png": [
		18194,
		18194
	],
	"./level1/pic4-2.png": [
		18999,
		18999
	],
	"./level1/pic4-3.png": [
		33116,
		33116
	],
	"./level1/pic4-4.png": [
		72954,
		72954
	],
	"./level1/pic4.png": [
		50851,
		50851
	],
	"./level1/pic40-1.png": [
		45097,
		45097
	],
	"./level1/pic40-2.png": [
		65667,
		65667
	],
	"./level1/pic40-3.png": [
		29774,
		29774
	],
	"./level1/pic40-4.png": [
		36443,
		36443
	],
	"./level1/pic40.png": [
		85022,
		85022
	],
	"./level1/pic41-1.png": [
		54146,
		54146
	],
	"./level1/pic41-2.png": [
		5300,
		5300
	],
	"./level1/pic41-3.png": [
		62297,
		62297
	],
	"./level1/pic41-4.png": [
		33690,
		33690
	],
	"./level1/pic41.png": [
		13825,
		13825
	],
	"./level1/pic42-1.png": [
		60835,
		60835
	],
	"./level1/pic42-2.png": [
		90923,
		90923
	],
	"./level1/pic42-3.png": [
		27823,
		27823
	],
	"./level1/pic42-4.png": [
		34714,
		34714
	],
	"./level1/pic42.png": [
		54280,
		54280
	],
	"./level1/pic43.png": [
		83566,
		83566
	],
	"./level1/pic44-1.png": [
		13233,
		13233
	],
	"./level1/pic44-2.png": [
		29469,
		29469
	],
	"./level1/pic44-3.png": [
		33018,
		33018
	],
	"./level1/pic44-4.png": [
		2746,
		2746
	],
	"./level1/pic44.png": [
		11866,
		11866
	],
	"./level1/pic45-1.png": [
		13977,
		13977
	],
	"./level1/pic45-2.png": [
		91465,
		91465
	],
	"./level1/pic45-3.png": [
		71137,
		71137
	],
	"./level1/pic45-4.png": [
		27341,
		27341
	],
	"./level1/pic45.png": [
		51607,
		51607
	],
	"./level1/pic46-1.png": [
		37447,
		37447
	],
	"./level1/pic46-2.png": [
		11998,
		11998
	],
	"./level1/pic46-3.png": [
		27754,
		27754
	],
	"./level1/pic46-4.png": [
		58181,
		58181
	],
	"./level1/pic46.png": [
		76338,
		76338
	],
	"./level1/pic47-1.png": [
		38775,
		38775
	],
	"./level1/pic47-2.png": [
		18447,
		18447
	],
	"./level1/pic47-3.png": [
		66870,
		66870
	],
	"./level1/pic47-4.png": [
		76048,
		76048
	],
	"./level1/pic47.png": [
		37984,
		37984
	],
	"./level1/pic48-1.png": [
		83905,
		83905
	],
	"./level1/pic48-2.png": [
		62526,
		62526
	],
	"./level1/pic48-3.png": [
		21076,
		21076
	],
	"./level1/pic48-4.png": [
		33048,
		33048
	],
	"./level1/pic48.png": [
		32041,
		32041
	],
	"./level1/pic5-1.png": [
		62637,
		62637
	],
	"./level1/pic5-2.png": [
		1728,
		1728
	],
	"./level1/pic5-3.png": [
		92064,
		92064
	],
	"./level1/pic5-4.png": [
		77406,
		77406
	],
	"./level1/pic5.png": [
		43489,
		43489
	],
	"./level1/pic6-1.png": [
		63474,
		63474
	],
	"./level1/pic6-2.png": [
		97605,
		97605
	],
	"./level1/pic6-3.png": [
		22623,
		22623
	],
	"./level1/pic6-4.png": [
		63946,
		63946
	],
	"./level1/pic6.png": [
		37246,
		37246
	],
	"./level1/pic7.png": [
		9561,
		9561
	],
	"./level1/pic8-1.png": [
		40680,
		40680
	],
	"./level1/pic8-2.png": [
		34530,
		34530
	],
	"./level1/pic8-3.png": [
		68535,
		68535
	],
	"./level1/pic8-4.png": [
		42046,
		42046
	],
	"./level1/pic8.png": [
		26802,
		26802
	],
	"./level1/pic9-1.png": [
		29170,
		29170
	],
	"./level1/pic9-2.png": [
		99922,
		99922
	],
	"./level1/pic9-3.png": [
		99200,
		99200
	],
	"./level1/pic9-4.png": [
		75880,
		75880
	],
	"./level1/pic9.png": [
		85563,
		85563
	],
	"./level2.png": [
		27043
	],
	"./level2/pic1.png": [
		48938,
		48938
	],
	"./level2/pic10-1.png": [
		26414,
		26414
	],
	"./level2/pic10-2.png": [
		65818,
		65818
	],
	"./level2/pic10-3.png": [
		3175,
		3175
	],
	"./level2/pic10-4.png": [
		73715,
		73715
	],
	"./level2/pic10.png": [
		87077,
		87077
	],
	"./level2/pic11-1.png": [
		56363,
		56363
	],
	"./level2/pic11-2.png": [
		53973,
		53973
	],
	"./level2/pic11-3.png": [
		13534,
		13534
	],
	"./level2/pic11-4.png": [
		83047,
		83047
	],
	"./level2/pic11.png": [
		94742,
		94742
	],
	"./level2/pic12-1.png": [
		19991,
		19991
	],
	"./level2/pic12-2.png": [
		18272,
		18272
	],
	"./level2/pic12-3.png": [
		61717,
		61717
	],
	"./level2/pic12-4.png": [
		72215,
		72215
	],
	"./level2/pic12.png": [
		40854,
		40854
	],
	"./level2/pic13.png": [
		49118,
		49118
	],
	"./level2/pic14-1.png": [
		42271,
		42271
	],
	"./level2/pic14-2.png": [
		16975,
		16975
	],
	"./level2/pic14-3.png": [
		10259,
		10259
	],
	"./level2/pic14-4.png": [
		99866,
		99866
	],
	"./level2/pic14.png": [
		94906,
		94906
	],
	"./level2/pic15-1.png": [
		58326,
		58326
	],
	"./level2/pic15-2.png": [
		39269,
		39269
	],
	"./level2/pic15-3.png": [
		92122,
		92122
	],
	"./level2/pic15-4.png": [
		5880,
		5880
	],
	"./level2/pic15.png": [
		63559,
		63559
	],
	"./level2/pic16-1.png": [
		81224,
		81224
	],
	"./level2/pic16-2.png": [
		53289,
		53289
	],
	"./level2/pic16-3.png": [
		6891,
		6891
	],
	"./level2/pic16-4.png": [
		79244,
		79244
	],
	"./level2/pic16.png": [
		61721,
		61721
	],
	"./level2/pic17-1.png": [
		43448,
		43448
	],
	"./level2/pic17-2.png": [
		67117,
		67117
	],
	"./level2/pic17-3.png": [
		42081,
		42081
	],
	"./level2/pic17-4.png": [
		16302,
		16302
	],
	"./level2/pic17.png": [
		92391,
		92391
	],
	"./level2/pic18-1.png": [
		53480,
		53480
	],
	"./level2/pic18-2.png": [
		28237,
		28237
	],
	"./level2/pic18-3.png": [
		37661,
		37661
	],
	"./level2/pic18-4.png": [
		53891,
		53891
	],
	"./level2/pic18.png": [
		22227,
		22227
	],
	"./level2/pic19.png": [
		10682,
		10682
	],
	"./level2/pic2-1.png": [
		21576,
		21576
	],
	"./level2/pic2-2.png": [
		87645,
		87645
	],
	"./level2/pic2-3.png": [
		66638,
		66638
	],
	"./level2/pic2-4.png": [
		33358,
		33358
	],
	"./level2/pic2.png": [
		60829,
		60829
	],
	"./level2/pic20-1.png": [
		34589,
		34589
	],
	"./level2/pic20-2.png": [
		22585,
		22585
	],
	"./level2/pic20-3.png": [
		91467,
		91467
	],
	"./level2/pic20-4.png": [
		42093,
		42093
	],
	"./level2/pic20.png": [
		6651,
		6651
	],
	"./level2/pic21-1.png": [
		39294,
		39294
	],
	"./level2/pic21-2.png": [
		19872,
		19872
	],
	"./level2/pic21-3.png": [
		65206,
		65206
	],
	"./level2/pic21-4.png": [
		28925,
		28925
	],
	"./level2/pic21.png": [
		60630,
		60630
	],
	"./level2/pic22-1.png": [
		17632,
		17632
	],
	"./level2/pic22-2.png": [
		38033,
		38033
	],
	"./level2/pic22-3.png": [
		46186,
		46186
	],
	"./level2/pic22-4.png": [
		1857,
		1857
	],
	"./level2/pic22.png": [
		59545,
		59545
	],
	"./level2/pic23-1.png": [
		84615,
		84615
	],
	"./level2/pic23-2.png": [
		41262,
		12216
	],
	"./level2/pic23-3.png": [
		19041,
		19041
	],
	"./level2/pic23-4.png": [
		69427,
		69427
	],
	"./level2/pic23.png": [
		24974,
		24974
	],
	"./level2/pic24-1.png": [
		10080,
		10080
	],
	"./level2/pic24-2.png": [
		69092,
		69092
	],
	"./level2/pic24-3.png": [
		5428,
		5428
	],
	"./level2/pic24-4.png": [
		18474,
		18474
	],
	"./level2/pic24.png": [
		87181,
		87181
	],
	"./level2/pic25.png": [
		32057,
		32057
	],
	"./level2/pic26-1.png": [
		9128,
		9128
	],
	"./level2/pic26-2.png": [
		22470,
		22470
	],
	"./level2/pic26-3.png": [
		76031,
		76031
	],
	"./level2/pic26-4.png": [
		8217,
		8217
	],
	"./level2/pic26.png": [
		77934,
		77934
	],
	"./level2/pic27-1.png": [
		98142,
		98142
	],
	"./level2/pic27-2.png": [
		91808,
		91808
	],
	"./level2/pic27-3.png": [
		85795,
		85795
	],
	"./level2/pic27-4.png": [
		30113,
		30113
	],
	"./level2/pic27.png": [
		53304,
		53304
	],
	"./level2/pic28-1.png": [
		26120,
		26120
	],
	"./level2/pic28-2.png": [
		61790,
		61790
	],
	"./level2/pic28-3.png": [
		14983,
		14983
	],
	"./level2/pic28-4.png": [
		2777,
		2777
	],
	"./level2/pic28.png": [
		13214,
		13214
	],
	"./level2/pic29-1.png": [
		67930,
		67930
	],
	"./level2/pic29-2.png": [
		99691,
		99691
	],
	"./level2/pic29-3.png": [
		18594,
		18594
	],
	"./level2/pic29-4.png": [
		69435,
		69435
	],
	"./level2/pic29.png": [
		30713,
		30713
	],
	"./level2/pic3-1.png": [
		70281,
		70281
	],
	"./level2/pic3-2.png": [
		67589,
		67589
	],
	"./level2/pic3-3.png": [
		90931,
		90931
	],
	"./level2/pic3-4.png": [
		91550,
		91550
	],
	"./level2/pic3.png": [
		27578,
		27578
	],
	"./level2/pic30-1.png": [
		21709,
		21709
	],
	"./level2/pic30-2.png": [
		45584,
		45584
	],
	"./level2/pic30-3.png": [
		10930,
		10930
	],
	"./level2/pic30-4.png": [
		80385,
		80385
	],
	"./level2/pic30.png": [
		55134,
		55134
	],
	"./level2/pic31.png": [
		60725,
		60725
	],
	"./level2/pic32-1.png": [
		76951,
		76951
	],
	"./level2/pic32-2.png": [
		72033,
		72033
	],
	"./level2/pic32-3.png": [
		18398,
		18398
	],
	"./level2/pic32-4.png": [
		17130,
		17130
	],
	"./level2/pic32.png": [
		36298,
		36298
	],
	"./level2/pic33-1.png": [
		41455,
		41455
	],
	"./level2/pic33-2.png": [
		35175,
		35175
	],
	"./level2/pic33-3.png": [
		77482,
		77482
	],
	"./level2/pic33-4.png": [
		55743,
		55743
	],
	"./level2/pic33.png": [
		15056,
		15056
	],
	"./level2/pic34-1.png": [
		82109,
		82109
	],
	"./level2/pic34-2.png": [
		13647,
		13647
	],
	"./level2/pic34-3.png": [
		66885,
		66885
	],
	"./level2/pic34-4.png": [
		58965,
		58965
	],
	"./level2/pic34.png": [
		66753,
		66753
	],
	"./level2/pic35-1.png": [
		39372,
		39372
	],
	"./level2/pic35-2.png": [
		96719,
		96719
	],
	"./level2/pic35-3.png": [
		8492,
		8492
	],
	"./level2/pic35-4.png": [
		33037,
		33037
	],
	"./level2/pic35.png": [
		14155,
		14155
	],
	"./level2/pic36-1.png": [
		93665,
		93665
	],
	"./level2/pic36-2.png": [
		49457,
		49457
	],
	"./level2/pic36-3.png": [
		97037,
		97037
	],
	"./level2/pic36-4.png": [
		19142,
		19142
	],
	"./level2/pic36.png": [
		25532,
		25532
	],
	"./level2/pic37.png": [
		46444,
		46444
	],
	"./level2/pic38-1.png": [
		19951,
		19951
	],
	"./level2/pic38-2.png": [
		91883,
		91883
	],
	"./level2/pic38-3.png": [
		32943,
		32943
	],
	"./level2/pic38-4.png": [
		71097,
		71097
	],
	"./level2/pic38.png": [
		18383,
		18383
	],
	"./level2/pic39-1.png": [
		66741,
		66741
	],
	"./level2/pic39-2.png": [
		25825,
		25825
	],
	"./level2/pic39-3.png": [
		74853,
		74853
	],
	"./level2/pic39-4.png": [
		10571,
		10571
	],
	"./level2/pic39.png": [
		22869,
		22869
	],
	"./level2/pic4-1.png": [
		19164,
		19164
	],
	"./level2/pic4-2.png": [
		21532,
		21532
	],
	"./level2/pic4-3.png": [
		90912,
		90912
	],
	"./level2/pic4-4.png": [
		87405,
		87405
	],
	"./level2/pic4.png": [
		58715,
		58715
	],
	"./level2/pic40-1.png": [
		18991,
		18991
	],
	"./level2/pic40-2.png": [
		22574,
		22574
	],
	"./level2/pic40-3.png": [
		53708,
		53708
	],
	"./level2/pic40-4.png": [
		43797,
		43797
	],
	"./level2/pic40.png": [
		24960,
		24960
	],
	"./level2/pic41-1.png": [
		82063,
		82063
	],
	"./level2/pic41-2.png": [
		72917,
		72917
	],
	"./level2/pic41-3.png": [
		28337,
		28337
	],
	"./level2/pic41-4.png": [
		95539,
		95539
	],
	"./level2/pic41.png": [
		50473,
		50473
	],
	"./level2/pic42-1.png": [
		81671,
		81671
	],
	"./level2/pic42-2.png": [
		21171,
		21171
	],
	"./level2/pic42-3.png": [
		93198,
		93198
	],
	"./level2/pic42-4.png": [
		12819,
		12819
	],
	"./level2/pic42.png": [
		72915,
		72915
	],
	"./level2/pic43.png": [
		33965,
		33965
	],
	"./level2/pic44-1.png": [
		59798,
		59798
	],
	"./level2/pic44-2.png": [
		24747,
		24747
	],
	"./level2/pic44-3.png": [
		28022,
		28022
	],
	"./level2/pic44-4.png": [
		46880,
		46880
	],
	"./level2/pic44.png": [
		87923,
		87923
	],
	"./level2/pic45-1.png": [
		15221,
		15221
	],
	"./level2/pic45-2.png": [
		60642,
		60642
	],
	"./level2/pic45-3.png": [
		62438,
		62438
	],
	"./level2/pic45-4.png": [
		90427,
		90427
	],
	"./level2/pic45.png": [
		94604,
		94604
	],
	"./level2/pic46-1.png": [
		45601,
		45601
	],
	"./level2/pic46-2.png": [
		52498,
		52498
	],
	"./level2/pic46-3.png": [
		65433,
		65433
	],
	"./level2/pic46-4.png": [
		28599,
		28599
	],
	"./level2/pic46.png": [
		32326,
		32326
	],
	"./level2/pic47-1.png": [
		69048,
		69048
	],
	"./level2/pic47-2.png": [
		7610,
		7610
	],
	"./level2/pic47-3.png": [
		80372,
		80372
	],
	"./level2/pic47-4.png": [
		17078,
		17078
	],
	"./level2/pic47.png": [
		35174,
		35174
	],
	"./level2/pic48-1.png": [
		65425,
		65425
	],
	"./level2/pic48-2.png": [
		49148,
		49148
	],
	"./level2/pic48-3.png": [
		7758,
		7758
	],
	"./level2/pic48-4.png": [
		38563,
		38563
	],
	"./level2/pic48.png": [
		30092,
		30092
	],
	"./level2/pic5-1.png": [
		67578,
		67578
	],
	"./level2/pic5-2.png": [
		8297,
		8297
	],
	"./level2/pic5-3.png": [
		65426,
		65426
	],
	"./level2/pic5-4.png": [
		41962,
		41962
	],
	"./level2/pic5.png": [
		38939,
		38939
	],
	"./level2/pic6-1.png": [
		87046,
		87046
	],
	"./level2/pic6-2.png": [
		20910,
		20910
	],
	"./level2/pic6-3.png": [
		87234,
		87234
	],
	"./level2/pic6-4.png": [
		99045,
		99045
	],
	"./level2/pic6.png": [
		24030,
		24030
	],
	"./level2/pic7.png": [
		78252,
		78252
	],
	"./level2/pic8-1.png": [
		17992,
		17992
	],
	"./level2/pic8-2.png": [
		66787,
		66787
	],
	"./level2/pic8-3.png": [
		91168,
		91168
	],
	"./level2/pic8-4.png": [
		708,
		708
	],
	"./level2/pic8.png": [
		82807,
		82807
	],
	"./level2/pic9-1.png": [
		43065,
		43065
	],
	"./level2/pic9-2.png": [
		32164,
		32164
	],
	"./level2/pic9-3.png": [
		68147,
		68147
	],
	"./level2/pic9-4.png": [
		3253,
		3253
	],
	"./level2/pic9.png": [
		54737,
		54737
	],
	"./level3.png": [
		12216
	],
	"./level3/pic1.png": [
		48022,
		48022
	],
	"./level3/pic10-1.png": [
		91999,
		91999
	],
	"./level3/pic10-2.png": [
		80884,
		80884
	],
	"./level3/pic10-3.png": [
		41424,
		41424
	],
	"./level3/pic10-4.png": [
		4758,
		4758
	],
	"./level3/pic10.png": [
		8313,
		8313
	],
	"./level3/pic11-1.png": [
		72794,
		72794
	],
	"./level3/pic11-2.png": [
		14062,
		14062
	],
	"./level3/pic11-3.png": [
		40355,
		40355
	],
	"./level3/pic11-4.png": [
		37241,
		37241
	],
	"./level3/pic11.png": [
		61869,
		61869
	],
	"./level3/pic12-1.png": [
		47116,
		47116
	],
	"./level3/pic12-2.png": [
		16111,
		16111
	],
	"./level3/pic12-3.png": [
		57172,
		57172
	],
	"./level3/pic12-4.png": [
		37270,
		37270
	],
	"./level3/pic12.png": [
		44062,
		44062
	],
	"./level3/pic13.png": [
		26812,
		26812
	],
	"./level3/pic14-1.png": [
		6520,
		6520
	],
	"./level3/pic14-2.png": [
		78952,
		78952
	],
	"./level3/pic14-3.png": [
		79813,
		79813
	],
	"./level3/pic14-4.png": [
		22133,
		22133
	],
	"./level3/pic14.png": [
		9395,
		9395
	],
	"./level3/pic15-1.png": [
		77498,
		77498
	],
	"./level3/pic15-2.png": [
		67628,
		67628
	],
	"./level3/pic15-3.png": [
		40079,
		40079
	],
	"./level3/pic15-4.png": [
		10792,
		10792
	],
	"./level3/pic15.png": [
		97306,
		97306
	],
	"./level3/pic16-1.png": [
		43523,
		43523
	],
	"./level3/pic16-2.png": [
		80338,
		80338
	],
	"./level3/pic16-3.png": [
		75310,
		75310
	],
	"./level3/pic16-4.png": [
		10640,
		10640
	],
	"./level3/pic16.png": [
		51913,
		51913
	],
	"./level3/pic17-1.png": [
		65373,
		65373
	],
	"./level3/pic17-2.png": [
		88,
		88
	],
	"./level3/pic17-3.png": [
		32039,
		32039
	],
	"./level3/pic17-4.png": [
		9616,
		9616
	],
	"./level3/pic17.png": [
		17810,
		17810
	],
	"./level3/pic18-1.png": [
		89996,
		89996
	],
	"./level3/pic18-2.png": [
		66059,
		66059
	],
	"./level3/pic18-3.png": [
		47708,
		47708
	],
	"./level3/pic18-4.png": [
		52830,
		52830
	],
	"./level3/pic18.png": [
		7526,
		7526
	],
	"./level3/pic19.png": [
		91675,
		91675
	],
	"./level3/pic2-1.png": [
		60590,
		60590
	],
	"./level3/pic2-2.png": [
		23462,
		23462
	],
	"./level3/pic2-3.png": [
		38901,
		38901
	],
	"./level3/pic2-4.png": [
		46634,
		46634
	],
	"./level3/pic2.png": [
		27022,
		27022
	],
	"./level3/pic20-1.png": [
		57088,
		57088
	],
	"./level3/pic20-2.png": [
		67123,
		67123
	],
	"./level3/pic20-3.png": [
		98583,
		98583
	],
	"./level3/pic20-4.png": [
		1147,
		1147
	],
	"./level3/pic20.png": [
		33739,
		33739
	],
	"./level3/pic21-1.png": [
		71067,
		71067
	],
	"./level3/pic21-2.png": [
		50450,
		50450
	],
	"./level3/pic21-3.png": [
		32994,
		32994
	],
	"./level3/pic21-4.png": [
		27527,
		27527
	],
	"./level3/pic21.png": [
		81609,
		81609
	],
	"./level3/pic22-1.png": [
		33289,
		33289
	],
	"./level3/pic22-2.png": [
		99559,
		99559
	],
	"./level3/pic22-3.png": [
		89578,
		89578
	],
	"./level3/pic22-4.png": [
		60754,
		60754
	],
	"./level3/pic22.png": [
		71433,
		71433
	],
	"./level3/pic23-1.png": [
		9582,
		9582
	],
	"./level3/pic23-2.png": [
		36553,
		36553
	],
	"./level3/pic23-3.png": [
		11535,
		11535
	],
	"./level3/pic23-4.png": [
		25001,
		25001
	],
	"./level3/pic23.png": [
		65102,
		65102
	],
	"./level3/pic24-1.png": [
		51756,
		51756
	],
	"./level3/pic24-2.png": [
		13805,
		13805
	],
	"./level3/pic24-3.png": [
		68324,
		68324
	],
	"./level3/pic24-4.png": [
		16936,
		16936
	],
	"./level3/pic24.png": [
		19210,
		19210
	],
	"./level3/pic3-1.png": [
		62682,
		62682
	],
	"./level3/pic3-2.png": [
		24392,
		24392
	],
	"./level3/pic3-3.png": [
		13809,
		13809
	],
	"./level3/pic3-4.png": [
		36965,
		36965
	],
	"./level3/pic3.png": [
		72922,
		72922
	],
	"./level3/pic4-1.png": [
		3803,
		3803
	],
	"./level3/pic4-2.png": [
		50175,
		50175
	],
	"./level3/pic4-3.png": [
		88930,
		88930
	],
	"./level3/pic4-4.png": [
		55350,
		55350
	],
	"./level3/pic4.png": [
		28786,
		28786
	],
	"./level3/pic5-1.png": [
		91500,
		91500
	],
	"./level3/pic5-2.png": [
		23799,
		23799
	],
	"./level3/pic5-3.png": [
		53794,
		53794
	],
	"./level3/pic5-4.png": [
		70557,
		70557
	],
	"./level3/pic5.png": [
		9549,
		9549
	],
	"./level3/pic6-1.png": [
		17610,
		17610
	],
	"./level3/pic6-2.png": [
		10385,
		10385
	],
	"./level3/pic6-3.png": [
		74893,
		74893
	],
	"./level3/pic6-4.png": [
		70731,
		70731
	],
	"./level3/pic6.png": [
		77487,
		77487
	],
	"./level3/pic7.png": [
		88613,
		88613
	],
	"./level3/pic8-1.png": [
		40691,
		40691
	],
	"./level3/pic8-2.png": [
		48019,
		48019
	],
	"./level3/pic8-3.png": [
		72571,
		72571
	],
	"./level3/pic8-4.png": [
		47192,
		47192
	],
	"./level3/pic8.png": [
		87501,
		87501
	],
	"./level3/pic9-1.png": [
		68306,
		68306
	],
	"./level3/pic9-2.png": [
		29781,
		29781
	],
	"./level3/pic9-3.png": [
		11933,
		11933
	],
	"./level3/pic9-4.png": [
		80812,
		80812
	],
	"./level3/pic9.png": [
		95555,
		95555
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 91645;
module.exports = webpackAsyncContext;